import * as React from "react";

import { cn } from "../../lib/utils";

const Textarea = React.forwardRef(({ className, ...props }, ref) => (
	<textarea
		ref={ref}
		className={cn(
			"flex w-full rounded-md border border-[var(--input-border-color)] bg-[var(--input-bg-color)] px-3 py-2 text-sm text-[var(--input-text-color)] shadow-sm transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-[var(--focus-ring-color)] disabled:cursor-not-allowed disabled:opacity-60",
			className
		)}
		{...props}
	/>
));
Textarea.displayName = "Textarea";

export { Textarea };
